/* Size guide dialog — open/close plus the IN/CM unit toggle.

   Delegated from `document`, so it works for a dialog injected after load (quick-add,
   a section re-render in the theme editor) with no re-init. */
(function () {
  var CM_PER_IN = 2.54;

  function open(dlg) {
    if (!dlg || dlg.classList.contains('is-open')) return;
    // Un-hide FIRST, then flip the class a frame later: `[hidden]` is `display: none`,
    // and an element going straight from that to its final opacity has nothing to
    // transition from — it would just appear.
    dlg.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        dlg.classList.add('is-open');
      });
    });
    document.documentElement.style.overflow = 'hidden';
    var first = dlg.querySelector('.sd-sizeguide__unit');
    if (first) first.focus();
  }

  function close(dlg) {
    if (!dlg || !dlg.classList.contains('is-open')) return;
    dlg.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    // Re-hide only once the fade has finished, or it vanishes instantly. Raced against
    // a timeout because `transitionend` never fires under prefers-reduced-motion.
    var done = function () {
      dlg.hidden = true;
      clearTimeout(t);
      dlg.removeEventListener('transitionend', done);
    };
    var t = setTimeout(done, 400);
    dlg.addEventListener('transitionend', done, { once: true });
    var opener = document.querySelector('[data-size-guide-open="' + dlg.id + '"]');
    if (opener) opener.focus();
  }

  function setUnit(dlg, unit) {
    dlg.querySelectorAll('.sd-sizeguide__unit').forEach(function (btn) {
      var on = btn.dataset.unit === unit;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    dlg.querySelectorAll('[data-in]').forEach(function (cell) {
      // Always converts from the ORIGINAL inches value in `data-in`, never from the
      // rendered text — otherwise switching back and forth compounds the rounding.
      var inches = parseFloat(cell.dataset.in);
      if (isNaN(inches)) return;
      cell.textContent =
        unit === 'cm' ? (Math.round(inches * CM_PER_IN * 10) / 10).toString() : cell.dataset.in;
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-size-guide-open]');
    if (opener) {
      open(document.getElementById(opener.dataset.sizeGuideOpen));
      return;
    }

    var dlg = e.target.closest('[data-size-guide]');
    if (!dlg) return;

    if (e.target.closest('[data-size-guide-close]')) {
      close(dlg);
      return;
    }
    var unit = e.target.closest('.sd-sizeguide__unit');
    if (unit) {
      setUnit(dlg, unit.dataset.unit);
      return;
    }
    // The backdrop IS the dialog element, so a click that reaches it rather than the
    // panel is by definition outside the panel.
    if (!e.target.closest('.sd-sizeguide__panel')) close(dlg);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openDlg = document.querySelector('[data-size-guide].is-open');
    if (openDlg) close(openDlg);
  });
})();
